import { call, put, takeEvery } from 'redux-saga/effects';
import callApi from 'utils/callApi';
import { LOCATION_CHANGE } from 'react-router-redux';

import { fetchAccountInformationSuccess } from 'redux/modules/account';
import { fetchAppInfoSuccess } from 'redux/modules/appInfo';
import { addNotification } from 'redux/modules/notifications';
import { saveRecoverOrder } from 'redux/modules/recoverOrder';
import { requestBulk } from 'redux/modules/bulk';

// Actions
export const FETCH_BUSINESS = 'FETCH_BUSINESS';
export const FETCH_BUSINESS_SUCCESS = 'FETCH_BUSINESS_SUCCESS';
export const FETCH_BUSINESS_FAIL = 'FETCH_BUSINESS_FAIL';
export const CREATE_BUSINESS = 'CREATE_BUSINESS';
export const CREATE_BUSINESS_SUCCESS = 'CREATE_BUSINESS_SUCCESS';
export const CREATE_BUSINESS_FAIL = 'CREATE_BUSINESS_FAIL';
export const UPDATE_BUSINESS = 'UPDATE_BUSINESS';
export const UPDATE_BUSINESS_SUCCESS = 'UPDATE_BUSINESS_SUCCESS';
export const UPDATE_BUSINESS_FAIL = 'UPDATE_BUSINESS_FAIL';
export const ADD_BUSINESS_RESOURCE = 'ADD_BUSINESS_RESOURCE';
export const ADD_BUSINESS_RESOURCE_SUCCESS = 'ADD_BUSINESS_RESOURCE_SUCCESS';
export const ADD_BUSINESS_RESOURCE_FAIL = 'ADD_BUSINESS_RESOURCE_FAIL';
export const CREATE_BUSINESS_CHANGE_CREDENTIALS = 'CREATE_BUSINESS_CHANGE_CREDENTIALS';
export const CREATE_BUSINESS_CHANGE_CREDENTIALS_SUCCESS = 'CREATE_BUSINESS_CHANGE_CREDENTIALS_SUCCESS';
export const CREATE_BUSINESS_CHANGE_CREDENTIALS_FAIL = 'CREATE_BUSINESS_CHANGE_CREDENTIALS_FAIL';
export const UPDATE_BUSINESS_CHANGE_CREDENTIALS = 'UPDATE_BUSINESS_CHANGE_CREDENTIALS';
export const UPDATE_BUSINESS_CHANGE_CREDENTIALS_SUCCESS = 'UPDATE_BUSINESS_CHANGE_CREDENTIALS_SUCCESS';
export const UPDATE_BUSINESS_CHANGE_CREDENTIALS_FAIL = 'UPDATE_BUSINESS_CHANGE_CREDENTIALS_FAIL';
export const CREATE_BUSINESS_TWILIO_CREDENTIALS = 'CREATE_BUSINESS_TWILIO_CREDENTIALS';
export const CREATE_BUSINESS_TWILIO_CREDENTIALS_SUCCESS = 'CREATE_BUSINESS_TWILIO_CREDENTIALS_SUCCESS';
export const CREATE_BUSINESS_TWILIO_CREDENTIALS_FAIL = 'CREATE_BUSINESS_TWILIO_CREDENTIALS_FAIL';
export const UPDATE_BUSINESS_TWILIO_CREDENTIALS = 'UPDATE_BUSINESS_TWILIO_CREDENTIALS';
export const UPDATE_BUSINESS_TWILIO_CREDENTIALS_SUCCESS = 'UPDATE_BUSINESS_TWILIO_CREDENTIALS_SUCCESS';
export const UPDATE_BUSINESS_TWILIO_CREDENTIALS_FAIL = 'UPDATE_BUSINESS_TWILIO_CREDENTIALS_FAIL';
export const CREATE_BUSINESS_CLAIM_MD_CREDENTIALS = 'CREATE_BUSINESS_CLAIM_MD_CREDENTIALS';
export const CREATE_BUSINESS_CLAIM_MD_CREDENTIALS_SUCCESS = 'CREATE_BUSINESS_CLAIM_MD_CREDENTIALS_SUCCESS';
export const CREATE_BUSINESS_CLAIM_MD_CREDENTIALS_FAIL = 'CREATE_BUSINESS_CLAIM_MD_CREDENTIALS_FAIL';
export const UPDATE_BUSINESS_CLAIM_MD_CREDENTIALS = 'UPDATE_BUSINESS_CLAIM_MD_CREDENTIALS';
export const UPDATE_BUSINESS_CLAIM_MD_CREDENTIALS_SUCCESS = 'UPDATE_BUSINESS_CLAIM_MD_CREDENTIALS_SUCCESS';
export const UPDATE_BUSINESS_CLAIM_MD_CREDENTIALS_FAIL = 'UPDATE_BUSINESS_CLAIM_MD_CREDENTIALS_FAIL';

// Reducer
export default function businessReducer(state = { data: {
  'Company Address': {
    'Time Zone': 'US/Eastern',
    'Observes Daylight Saving': false,
  },
}, loading: 0 }, action) {
  const { type } = action;
  let triggerLoading;
  let payload;
  if (action.payload) {
    ({ triggerLoading, ...payload } = action.payload);
  }
  switch (type) {
    case FETCH_BUSINESS:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading + 1 } : {},
      };
    case FETCH_BUSINESS_SUCCESS:
      return {
        ...state,
        ...payload,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case FETCH_BUSINESS_FAIL:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case CREATE_BUSINESS_SUCCESS:
    case ADD_BUSINESS_RESOURCE_SUCCESS: {
      return {
        ...state,
        data: payload,
      };
    }
    case UPDATE_BUSINESS_SUCCESS: {
      return {
        ...state,
        data: {
          ...state.data,
          ...payload,
        },
      };
    }
    case CREATE_BUSINESS_CHANGE_CREDENTIALS_SUCCESS:
    case UPDATE_BUSINESS_CHANGE_CREDENTIALS_SUCCESS: {
      return {
        ...state,
        data: {
          ...state.data,
          'Change Credentials': payload,
        },
      };
    }
    case CREATE_BUSINESS_TWILIO_CREDENTIALS_SUCCESS:
    case UPDATE_BUSINESS_TWILIO_CREDENTIALS_SUCCESS: {
      return {
        ...state,
        data: {
          ...state.data,
          'Twilio Credentials': payload['Twilio Credentials'],
        },
      };
    }
    case CREATE_BUSINESS_CLAIM_MD_CREDENTIALS_SUCCESS:
    case UPDATE_BUSINESS_CLAIM_MD_CREDENTIALS_SUCCESS: {
      return {
        ...state,
        data: {
          ...state.data,
          'Claim MD Credentials': payload,
        },
      };
    }
    case LOCATION_CHANGE:
      return {
        ...state,
        loading: 0,
      };
    default:
      return state;
  }
}

// Action Creators
export function fetchBusiness(payload) {
  return { type: FETCH_BUSINESS, payload };
}

export function fetchBusinessSuccess(payload) {
  return { type: FETCH_BUSINESS_SUCCESS, payload };
}

export function fetchBusinessFail(payload) {
  return { type: FETCH_BUSINESS_FAIL, payload };
}

export function createBusiness(payload) {
  return { type: CREATE_BUSINESS, payload };
}

export function createBusinessSuccess(payload) {
  return { type: CREATE_BUSINESS_SUCCESS, payload };
}

export function createBusinessFail(payload) {
  return { type: CREATE_BUSINESS_FAIL, payload };
}

export function updateBusiness(payload) {
  return { type: UPDATE_BUSINESS, payload };
}

export function updateBusinessSuccess(payload) {
  return { type: UPDATE_BUSINESS_SUCCESS, payload };
}

export function updateBusinessFail(payload) {
  return { type: UPDATE_BUSINESS_FAIL, payload };
}

export function addBusinessResource(payload) {
  return { type: ADD_BUSINESS_RESOURCE, payload };
}

export function addBusinessResourceSuccess(payload) {
  return { type: ADD_BUSINESS_RESOURCE_SUCCESS, payload };
}

export function addBusinessResourceFail(payload) {
  return { type: ADD_BUSINESS_RESOURCE_FAIL, payload };
}

export function createBusinessChangeCredentials(payload) {
  return { type: CREATE_BUSINESS_CHANGE_CREDENTIALS, payload };
}

export function createBusinessChangeCredentialsSuccess(payload) {
  return { type: CREATE_BUSINESS_CHANGE_CREDENTIALS_SUCCESS, payload };
}

export function createBusinessChangeCredentialsFail(payload) {
  return { type: CREATE_BUSINESS_CHANGE_CREDENTIALS_FAIL, payload };
}

export function updateBusinessChangeCredentials(payload) {
  return { type: UPDATE_BUSINESS_CHANGE_CREDENTIALS, payload };
}

export function updateBusinessChangeCredentialsSuccess(payload) {
  return { type: UPDATE_BUSINESS_CHANGE_CREDENTIALS_SUCCESS, payload };
}

export function updateBusinessChangeCredentialsFail(payload) {
  return { type: UPDATE_BUSINESS_CHANGE_CREDENTIALS_FAIL, payload };
}

export function createBusinessTwilioCredentials(payload) {
  return { type: CREATE_BUSINESS_TWILIO_CREDENTIALS, payload };
}

export function createBusinessTwilioCredentialsSuccess(payload) {
  return { type: CREATE_BUSINESS_TWILIO_CREDENTIALS_SUCCESS, payload };
}

export function createBusinessTwilioCredentialsFail(payload) {
  return { type: CREATE_BUSINESS_TWILIO_CREDENTIALS_FAIL, payload };
}

export function updateBusinessTwilioCredentials(payload) {
  return { type: UPDATE_BUSINESS_TWILIO_CREDENTIALS, payload };
}

export function updateBusinessTwilioCredentialsSuccess(payload) {
  return { type: UPDATE_BUSINESS_TWILIO_CREDENTIALS_SUCCESS, payload };
}

export function updateBusinessTwilioCredentialsFail(payload) {
  return { type: UPDATE_BUSINESS_TWILIO_CREDENTIALS_FAIL, payload };
}

export function createBusinessClaimMDCredentials(payload) {
  return { type: CREATE_BUSINESS_CLAIM_MD_CREDENTIALS, payload };
}

export function createBusinessClaimMDCredentialsSuccess(payload) {
  return { type: CREATE_BUSINESS_CLAIM_MD_CREDENTIALS_SUCCESS, payload };
}

export function createBusinessClaimMDCredentialsFail(payload) {
  return { type: CREATE_BUSINESS_CLAIM_MD_CREDENTIALS_FAIL, payload };
}

export function updateBusinessClaimMDCredentials(payload) {
  return { type: UPDATE_BUSINESS_CLAIM_MD_CREDENTIALS, payload };
}

export function updateBusinessClaimMDCredentialsSuccess(payload) {
  return { type: UPDATE_BUSINESS_CLAIM_MD_CREDENTIALS_SUCCESS, payload };
}

export function updateBusinessClaimMDCredentialsFail(payload) {
  return { type: UPDATE_BUSINESS_CLAIM_MD_CREDENTIALS_FAIL, payload };
}

// Requests
export function requestFetchBusiness() {
  return callApi('settings/company/?limit=1&offset=0');
}

export function requestCreateBusiness(payload) {
  return callApi('settings/company/', 'POST', payload);
}

export function requestUpdateBusiness(payload) {
  return callApi('settings/company/', 'PATCH', payload);
}

export function requestAddBusinessResource(payload) {
  return callApi('settings/company/change_resource/add/', 'POST', payload);
}

export function requestCreateBusinessDocument(payload) {
  return callApi('settings/document/', 'POST', payload, false);
}

export function requestDeleteBusinessDocument(payload) {
  return callApi(`settings/document/?id=${payload.ID}`, 'DELETE');
}

export function requestCreateBusinessChangeCredentials(payload) {
  return callApi('change/credentials/', 'POST', payload);
}

export function requestUpdateBusinessChangeCredentials(payload) {
  return callApi('change/credentials/', 'PATCH', payload);
}

export function requestCreateBusinessTwilioCredentials(payload) {
  return callApi('settings/twilio_credentials/', 'POST', payload);
}

export function requestUpdateBusinessTwilioCredentials(payload) {
  return callApi('settings/twilio_credentials/', 'PUT', payload);
}

export function requestCreateBusinessClaimMDCredentials(payload) {
  return callApi('claim_md/credentials/', 'POST', payload);
}

export function requestUpdateBusinessClaimMDCredentials(payload) {
  return callApi('claim_md/credentials/', 'PATCH', payload);
}

export function requestCreateBusinessCompanyInfo(payload) {
  return callApi('settings/company_info/', 'POST', payload);
}

export function requestUpdateBusinessCompanyInfo(payload) {
  return callApi('settings/company_info/', 'PATCH', payload);
}

// Sagas
function* fetchBusinessSaga(action) {
  const { triggerLoading, recoverOrderValues } = action.payload;
  try {
    const res = yield call(requestFetchBusiness);
    yield put(fetchBusinessSuccess({
      data: res.data[0] || {},
      triggerLoading,
    }));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
  } catch (err) {
    if (err.data.error === 'Access Error' && recoverOrderValues) {
      yield put(saveRecoverOrder(recoverOrderValues));
    }
    yield put(fetchBusinessFail({
      ...err.data,
      triggerLoading,
    }));
  }
}

function* createBusinessSaga(action) {
  const {
    values: {
      Image,
      ...otherValues
    },
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestCreateBusiness, otherValues);
    yield put(createBusinessSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    if (Image) {
      const formData = new FormData();
      formData.append('object_id', res.data.ID);
      if (Image.noFileConstructor) {
        delete Image.noFileConstructor;
        formData.append('file', Image, Image.name);
      } else {
        formData.append('file', Image);
      }
      const image = yield call(requestCreateBusinessDocument, formData);
      const updateRes = yield call(requestUpdateBusiness, { ID: res.data.ID, 'Image ID': image.data.ID });
      yield put(updateBusinessSuccess(updateRes.data));
      yield put(fetchAccountInformationSuccess(updateRes.user_info));
      yield put(fetchAppInfoSuccess(updateRes.app_info));
      yield put(addNotification({
        message: 'Business information updated',
        variant: 'success',
      }));
      if (resolve) {
        resolve(updateRes.data);
      }
    } else {
      yield put(addNotification({
        message: 'New business successfully created',
        variant: 'success',
      }));
      if (resolve) {
        resolve(res.data);
      }
    }
  } catch (err) {
    yield put(createBusinessFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* updateBusinessSaga(action) {
  const {
    resolve,
    reject,
    values: {
      ID,
      Image,
      Agreement,
      ...otherValues
    },
    showNotification = true,
  } = action.payload;
  try {
    let imageRes;
    let agreementRes;
    if (Agreement) {
      const formData = new FormData();
      formData.append('object_id', ID);
      formData.append('file', Agreement, 'Agreement.pdf');
      agreementRes = yield call(requestCreateBusinessDocument, formData);
    }
    if (Image) {
      const formData = new FormData();
      formData.append('object_id', ID);
      if (Image.noFileConstructor) {
        delete Image.noFileConstructor;
        formData.append('file', Image, Image.name);
      } else {
        formData.append('file', Image);
      }
      imageRes = yield call(requestCreateBusinessDocument, formData);
    }
    const res = yield call(requestBulk, {
      ...Image === null ? { 'Company': {
        URL: 'settings/company/',
        METHOD: 'PATCH',
        BODY: {
          ID,
          'Image ID': null,
        },
      } } : {},
      ...imageRes && imageRes.data.ID ? { 'Company': {
        URL: 'settings/company/',
        METHOD: 'PATCH',
        BODY: {
          ID,
          'Image ID': imageRes.data.ID,
        },
      } } : {},
      ...agreementRes && agreementRes.data.ID ? { 'Company': {
        URL: 'settings/company/',
        METHOD: 'PATCH',
        BODY: {
          ID,
          'Agreement ID': agreementRes.data.ID,
        },
      } } : {},
      ...otherValues['Company Info'] ? { 'Company Info': {
        URL: 'settings/company_info/',
        METHOD: 'PATCH',
        BODY: otherValues['Company Info'],
      } } : {},
      ...otherValues['Company Contact'] ? { 'Company Contact': {
        URL: 'settings/company_contact/',
        METHOD: 'PATCH',
        BODY: otherValues['Company Contact'],
      } } : {},
      ...otherValues['Company Address'] ? { 'Company Address': {
        URL: 'settings/company_address/',
        METHOD: otherValues['Company Address']['Company ID'] ? 'POST' : 'PATCH',
        BODY: otherValues['Company Address'],
      } } : {},
      ...otherValues['Company Identify'] ? { 'Company Identify': {
        URL: 'settings/company_identify/',
        METHOD: otherValues['Company Identify']['Company ID'] ? 'POST' : 'PATCH',
        BODY: otherValues['Company Identify'],
      } } : {},
    });
    const businessRes = {
      ...res.data.Company ? { ...res.data.Company.data } : {},
      ...res.data['Company Info'] ? {
        'Company Info': res.data['Company Info'].data,
      } : {},
      ...res.data['Company Contact'] ? {
        'Company Contact': res.data['Company Contact'].data,
      } : {},
      ...res.data['Company Address'] ? {
        'Company Address': res.data['Company Address'].data,
      } : {},
      ...res.data['Company Identify'] ? {
        'Company Identify': res.data['Company Identify'].data,
      } : {},
    };
    yield put(updateBusinessSuccess(businessRes));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    if (showNotification) {
      yield put(addNotification({
        message: 'Business information updated',
        variant: 'success',
      }));
    }
    if (resolve) {
      resolve(businessRes);
    }
  } catch (err) {
    yield put(updateBusinessFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* addBusinessResourceSaga(action) {
  try {
    const res = yield call(requestAddBusinessResource, action.payload);
    yield put(addBusinessResourceSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
  } catch (err) {
    yield put(addBusinessResourceFail(err.data));
  }
}

function* createBusinessChangeCredentialsSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestCreateBusinessChangeCredentials, values);
    yield put(createBusinessChangeCredentialsSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    yield put(addNotification({
      message: 'New change credentials successfully created',
      variant: 'success',
    }));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(createBusinessChangeCredentialsFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* updateBusinessChangeCredentialsSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestUpdateBusinessChangeCredentials, values);
    yield put(updateBusinessChangeCredentialsSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    yield put(addNotification({
      message: 'Change credentials successfully updated',
      variant: 'success',
    }));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(createBusinessChangeCredentialsFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* createBusinessTwilioCredentialsSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestCreateBusinessTwilioCredentials, values);
    yield put(createBusinessTwilioCredentialsSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    yield put(addNotification({
      message: 'New Twilio credentials were successfully created',
      variant: 'success',
    }));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(createBusinessTwilioCredentialsFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* updateBusinessTwilioCredentialsSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestUpdateBusinessTwilioCredentials, values);
    yield put(updateBusinessTwilioCredentialsSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    yield put(addNotification({
      message: 'Twilio credentials successfully updated',
      variant: 'success',
    }));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(createBusinessTwilioCredentialsFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* createBusinessClaimMDCredentialsSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestCreateBusinessClaimMDCredentials, values);
    yield put(createBusinessClaimMDCredentialsSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    yield put(addNotification({
      message: 'New Claim MD credentials were successfully created',
      variant: 'success',
    }));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(createBusinessTwilioCredentialsFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* updateBusinessClaimMDCredentialsSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestUpdateBusinessClaimMDCredentials, values);
    yield put(updateBusinessClaimMDCredentialsSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    yield put(addNotification({
      message: 'Claim MD credentials successfully updated',
      variant: 'success',
    }));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(createBusinessTwilioCredentialsFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

export function* businessSaga() {
  yield takeEvery(FETCH_BUSINESS, fetchBusinessSaga);
  yield takeEvery(CREATE_BUSINESS, createBusinessSaga);
  yield takeEvery(UPDATE_BUSINESS, updateBusinessSaga);
  yield takeEvery(ADD_BUSINESS_RESOURCE, addBusinessResourceSaga);
  yield takeEvery(CREATE_BUSINESS_CHANGE_CREDENTIALS, createBusinessChangeCredentialsSaga);
  yield takeEvery(UPDATE_BUSINESS_CHANGE_CREDENTIALS, updateBusinessChangeCredentialsSaga);
  yield takeEvery(CREATE_BUSINESS_TWILIO_CREDENTIALS, createBusinessTwilioCredentialsSaga);
  yield takeEvery(UPDATE_BUSINESS_TWILIO_CREDENTIALS, updateBusinessTwilioCredentialsSaga);
  yield takeEvery(CREATE_BUSINESS_CLAIM_MD_CREDENTIALS, createBusinessClaimMDCredentialsSaga);
  yield takeEvery(UPDATE_BUSINESS_CLAIM_MD_CREDENTIALS, updateBusinessClaimMDCredentialsSaga);
}



// WEBPACK FOOTER //
// ./src/redux/modules/business.js